import React, { FC } from 'react'
import { ProductReviews } from '@moonpig/web-shared-products'
import {
  AccordionContent,
  AccordionHeading,
} from '@moonpig/launchpad-components'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { useProductContext } from '../../../../contexts/product'
import { AccordionSections } from '../types'

export const ReviewsModule: FC = () => {
  const [
    {
      product: { id, rating },
    },
  ] = useProductContext()

  const localiseText = useCoreLocaleText()

  return rating && rating.count && rating.count > 0 ? (
    <AccordionContent
      heading={
        <AccordionHeading level="h2">
          {localiseText('common.reviews')}
        </AccordionHeading>
      }
      value={AccordionSections.Reviews}
    >
      <ProductReviews id={id} />
    </AccordionContent>
  ) : null
}
